export default __webpack_public_path__ + "static/media/fundoMobile.f2889ba4.png";